import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/regenerator/index.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { getLogger, getPosition } from "../Utils/Utils";
import { InteractionManager } from "./Utils/InteractionManager";
import { Particle } from "./Particle";
import { Point } from "./Utils/Point";
import { QuadTree } from "./Utils/QuadTree";
import { Rectangle } from "./Utils/Rectangle";
import { errorPrefix } from "./Utils/Constants";
var qTreeCapacity = 4;

var qTreeRectangle = function qTreeRectangle(canvasSize) {
  return new Rectangle(-canvasSize.width / 4, -canvasSize.height / 4, canvasSize.width * 3 / 2, canvasSize.height * 3 / 2);
};

export var Particles = /*#__PURE__*/function () {
  function Particles(engine, container) {
    var _this = this;

    _classCallCheck(this, Particles);

    this._applyDensity = function (options, manualCount, group) {
      var _options$number$densi;

      if (!((_options$number$densi = options.number.density) !== null && _options$number$densi !== void 0 && _options$number$densi.enable)) {
        return;
      }

      var numberOptions = options.number,
          densityFactor = _this._initDensityFactor(numberOptions.density),
          optParticlesNumber = numberOptions.value,
          optParticlesLimit = numberOptions.limit > 0 ? numberOptions.limit : optParticlesNumber,
          particlesNumber = Math.min(optParticlesNumber, optParticlesLimit) * densityFactor + manualCount,
          particlesCount = Math.min(_this.count, _this.filter(function (t) {
        return t.group === group;
      }).length);

      _this.limit = numberOptions.limit * densityFactor;

      if (particlesCount < particlesNumber) {
        _this.push(Math.abs(particlesNumber - particlesCount), undefined, options, group);
      } else if (particlesCount > particlesNumber) {
        _this.removeQuantity(particlesCount - particlesNumber, group);
      }
    };

    this._initDensityFactor = function (densityOptions) {
      var container = _this._container;

      if (!container.canvas.element || !densityOptions.enable) {
        return 1;
      }

      var canvas = container.canvas.element,
          pxRatio = container.retina.pixelRatio;
      return canvas.width * canvas.height / (densityOptions.factor * Math.pow(pxRatio, 2) * densityOptions.area);
    };

    this._pushParticle = function (position, overrideOptions, group, initializer) {
      try {
        var particle = _this.pool.pop();

        if (particle) {
          particle.init(_this._nextId, position, overrideOptions, group);
        } else {
          particle = new Particle(_this._engine, _this._nextId, _this._container, position, overrideOptions, group);
        }

        var canAdd = true;

        if (initializer) {
          canAdd = initializer(particle);
        }

        if (!canAdd) {
          return;
        }

        _this._array.push(particle);

        _this._zArray.push(particle);

        _this._nextId++;

        _this._engine.dispatchEvent("particleAdded", {
          container: _this._container,
          data: {
            particle: particle
          }
        });

        return particle;
      } catch (e) {
        getLogger().warning("".concat(errorPrefix, " adding particle: ").concat(e));
        return;
      }
    };

    this._removeParticle = function (index, group, override) {
      var particle = _this._array[index];

      if (!particle || particle.group !== group) {
        return false;
      }

      particle.destroy(override);

      var zIdx = _this._zArray.indexOf(particle);

      _this._array.splice(index, 1);

      _this._zArray.splice(zIdx, 1);

      _this.pool.push(particle);

      _this._engine.dispatchEvent("particleRemoved", {
        container: _this._container,
        data: {
          particle: particle
        }
      });

      return true;
    };

    this._engine = engine;
    this._container = container;
    this._nextId = 0;
    this._array = [];
    this._zArray = [];
    this.pool = [];
    this.limit = 0;
    this.needsSort = false;
    this.lastZIndex = 0;
    this._interactionManager = new InteractionManager(this._engine, this._container);
    var canvasSize = this._container.canvas.size;
    this.quadTree = new QuadTree(qTreeRectangle(canvasSize), qTreeCapacity);
    this.movers = this._engine.plugins.getMovers(this._container, true);
    this.updaters = this._engine.plugins.getUpdaters(this._container, true);
  }

  _createClass(Particles, [{
    key: "count",
    get: function get() {
      return this._array.length;
    }
  }, {
    key: "addManualParticles",
    value: function addManualParticles() {
      var container = this._container,
          options = container.actualOptions;

      var _iterator = _createForOfIteratorHelper(options.manualParticles),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var particle = _step.value;
          this.addParticle(particle.position ? getPosition(particle.position, container.canvas.size) : undefined, particle.options);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "addParticle",
    value: function addParticle(position, overrideOptions, group, initializer) {
      var container = this._container,
          options = container.actualOptions,
          limit = options.particles.number.limit;

      if (limit > 0) {
        var countToRemove = this.count + 1 - limit;

        if (countToRemove > 0) {
          this.removeQuantity(countToRemove);
        }
      }

      return this._pushParticle(position, overrideOptions, group, initializer);
    }
  }, {
    key: "clear",
    value: function clear() {
      this._array = [];
      this._zArray = [];
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this._array = [];
      this._zArray = [];
      this.movers = [];
      this.updaters = [];
    }
  }, {
    key: "draw",
    value: function () {
      var _draw = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(delta) {
        var container, _iterator2, _step2, _step2$value, plugin, _iterator3, _step3, p;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                container = this._container;
                _context.next = 3;
                return this.update(delta);

              case 3:
                container.canvas.clear();
                _iterator2 = _createForOfIteratorHelper(container.plugins);

                try {
                  for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                    _step2$value = _slicedToArray(_step2.value, 2), plugin = _step2$value[1];
                    container.canvas.drawPlugin(plugin, delta);
                  }
                } catch (err) {
                  _iterator2.e(err);
                } finally {
                  _iterator2.f();
                }

                _iterator3 = _createForOfIteratorHelper(this._zArray);

                try {
                  for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                    p = _step3.value;
                    p.draw(delta);
                  }
                } catch (err) {
                  _iterator3.e(err);
                } finally {
                  _iterator3.f();
                }

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function draw(_x) {
        return _draw.apply(this, arguments);
      }

      return draw;
    }()
  }, {
    key: "filter",
    value: function filter(condition) {
      return this._array.filter(condition);
    }
  }, {
    key: "find",
    value: function find(condition) {
      return this._array.find(condition);
    }
  }, {
    key: "handleClickMode",
    value: function handleClickMode(mode) {
      this._interactionManager.handleClickMode(mode);
    }
  }, {
    key: "init",
    value: function init() {
      var container = this._container,
          options = container.actualOptions;
      this.lastZIndex = 0;
      this.needsSort = false;
      var handled = false;
      this.updaters = this._engine.plugins.getUpdaters(container, true);

      this._interactionManager.init();

      var _iterator4 = _createForOfIteratorHelper(container.plugins),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var _step4$value = _slicedToArray(_step4.value, 2),
              plugin = _step4$value[1];

          if (plugin.particlesInitialization !== undefined) {
            handled = plugin.particlesInitialization();
          }

          if (handled) {
            break;
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      this._interactionManager.init();

      var _iterator5 = _createForOfIteratorHelper(container.pathGenerators),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var _step5$value = _slicedToArray(_step5.value, 2),
              pathGenerator = _step5$value[1];

          pathGenerator.init(container);
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }

      this.addManualParticles();

      if (!handled) {
        for (var group in options.particles.groups) {
          var groupOptions = options.particles.groups[group];

          for (var i = this.count, j = 0; j < ((_groupOptions$number = groupOptions.number) === null || _groupOptions$number === void 0 ? void 0 : _groupOptions$number.value) && i < options.particles.number.value; i++, j++) {
            var _groupOptions$number;

            this.addParticle(undefined, groupOptions, group);
          }
        }

        for (var _i = this.count; _i < options.particles.number.value; _i++) {
          this.addParticle();
        }
      }
    }
  }, {
    key: "push",
    value: function push(nb, mouse, overrideOptions, group) {
      this.pushing = true;

      for (var i = 0; i < nb; i++) {
        this.addParticle(mouse === null || mouse === void 0 ? void 0 : mouse.position, overrideOptions, group);
      }

      this.pushing = false;
    }
  }, {
    key: "redraw",
    value: function () {
      var _redraw = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.clear();
                this.init();
                _context2.next = 4;
                return this.draw({
                  value: 0,
                  factor: 0
                });

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function redraw() {
        return _redraw.apply(this, arguments);
      }

      return redraw;
    }()
  }, {
    key: "remove",
    value: function remove(particle, group, override) {
      this.removeAt(this._array.indexOf(particle), undefined, group, override);
    }
  }, {
    key: "removeAt",
    value: function removeAt(index) {
      var quantity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var group = arguments.length > 2 ? arguments[2] : undefined;
      var override = arguments.length > 3 ? arguments[3] : undefined;

      if (index < 0 || index > this.count) {
        return;
      }

      var deleted = 0;

      for (var i = index; deleted < quantity && i < this.count; i++) {
        this._removeParticle(i--, group, override) && deleted++;
      }
    }
  }, {
    key: "removeQuantity",
    value: function removeQuantity(quantity, group) {
      this.removeAt(0, quantity, group);
    }
  }, {
    key: "setDensity",
    value: function setDensity() {
      var options = this._container.actualOptions,
          groups = options.particles.groups;

      for (var group in groups) {
        this._applyDensity(groups[group], 0, group);
      }

      this._applyDensity(options.particles, options.manualParticles.length);
    }
  }, {
    key: "update",
    value: function () {
      var _update = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(delta) {
        var container, particlesToDelete, _iterator6, _step6, _step6$value, pathGenerator, _iterator7, _step7, _step7$value, plugin, _iterator8, _step8, particle, resizeFactor, _iterator10, _step10, _step10$value, _plugin, _iterator11, _step11, mover, _iterator9, _step9, _particle, _iterator12, _step12, updater, zArray;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                container = this._container, particlesToDelete = new Set();
                this.quadTree = new QuadTree(qTreeRectangle(container.canvas.size), qTreeCapacity);
                _iterator6 = _createForOfIteratorHelper(container.pathGenerators);

                try {
                  for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
                    _step6$value = _slicedToArray(_step6.value, 2), pathGenerator = _step6$value[1];
                    pathGenerator.update();
                  }
                } catch (err) {
                  _iterator6.e(err);
                } finally {
                  _iterator6.f();
                }

                _iterator7 = _createForOfIteratorHelper(container.plugins);

                try {
                  for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
                    _step7$value = _slicedToArray(_step7.value, 2), plugin = _step7$value[1];
                    plugin.update && plugin.update(delta);
                  }
                } catch (err) {
                  _iterator7.e(err);
                } finally {
                  _iterator7.f();
                }

                _iterator8 = _createForOfIteratorHelper(this._array);
                _context3.prev = 7;

                _iterator8.s();

              case 9:
                if ((_step8 = _iterator8.n()).done) {
                  _context3.next = 42;
                  break;
                }

                particle = _step8.value;
                resizeFactor = container.canvas.resizeFactor;

                if (resizeFactor && !particle.ignoresResizeRatio) {
                  particle.position.x *= resizeFactor.width;
                  particle.position.y *= resizeFactor.height;
                  particle.initialPosition.x *= resizeFactor.width;
                  particle.initialPosition.y *= resizeFactor.height;
                }

                particle.ignoresResizeRatio = false;
                _context3.next = 16;
                return this._interactionManager.reset(particle);

              case 16:
                _iterator10 = _createForOfIteratorHelper(this._container.plugins);
                _context3.prev = 17;

                _iterator10.s();

              case 19:
                if ((_step10 = _iterator10.n()).done) {
                  _context3.next = 26;
                  break;
                }

                _step10$value = _slicedToArray(_step10.value, 2), _plugin = _step10$value[1];

                if (!particle.destroyed) {
                  _context3.next = 23;
                  break;
                }

                return _context3.abrupt("break", 26);

              case 23:
                if (_plugin.particleUpdate) {
                  _plugin.particleUpdate(particle, delta);
                }

              case 24:
                _context3.next = 19;
                break;

              case 26:
                _context3.next = 31;
                break;

              case 28:
                _context3.prev = 28;
                _context3.t0 = _context3["catch"](17);

                _iterator10.e(_context3.t0);

              case 31:
                _context3.prev = 31;

                _iterator10.f();

                return _context3.finish(31);

              case 34:
                _iterator11 = _createForOfIteratorHelper(this.movers);

                try {
                  for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
                    mover = _step11.value;
                    mover.isEnabled(particle) && mover.move(particle, delta);
                  }
                } catch (err) {
                  _iterator11.e(err);
                } finally {
                  _iterator11.f();
                }

                if (!particle.destroyed) {
                  _context3.next = 39;
                  break;
                }

                particlesToDelete.add(particle);
                return _context3.abrupt("continue", 40);

              case 39:
                this.quadTree.insert(new Point(particle.getPosition(), particle));

              case 40:
                _context3.next = 9;
                break;

              case 42:
                _context3.next = 47;
                break;

              case 44:
                _context3.prev = 44;
                _context3.t1 = _context3["catch"](7);

                _iterator8.e(_context3.t1);

              case 47:
                _context3.prev = 47;

                _iterator8.f();

                return _context3.finish(47);

              case 50:
                this._array = this.filter(function (t) {
                  return !particlesToDelete.has(t);
                });
                _context3.next = 53;
                return this._interactionManager.externalInteract(delta);

              case 53:
                _iterator9 = _createForOfIteratorHelper(this._array);
                _context3.prev = 54;

                _iterator9.s();

              case 56:
                if ((_step9 = _iterator9.n()).done) {
                  _context3.next = 65;
                  break;
                }

                _particle = _step9.value;
                _iterator12 = _createForOfIteratorHelper(this.updaters);

                try {
                  for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
                    updater = _step12.value;
                    updater.update(_particle, delta);
                  }
                } catch (err) {
                  _iterator12.e(err);
                } finally {
                  _iterator12.f();
                }

                if (!(!_particle.destroyed && !_particle.spawning)) {
                  _context3.next = 63;
                  break;
                }

                _context3.next = 63;
                return this._interactionManager.particlesInteract(_particle, delta);

              case 63:
                _context3.next = 56;
                break;

              case 65:
                _context3.next = 70;
                break;

              case 67:
                _context3.prev = 67;
                _context3.t2 = _context3["catch"](54);

                _iterator9.e(_context3.t2);

              case 70:
                _context3.prev = 70;

                _iterator9.f();

                return _context3.finish(70);

              case 73:
                delete container.canvas.resizeFactor;

                if (this.needsSort) {
                  zArray = this._zArray;
                  zArray.sort(function (a, b) {
                    return b.position.z - a.position.z || a.id - b.id;
                  });
                  this.lastZIndex = zArray[zArray.length - 1].position.z;
                  this.needsSort = false;
                }

              case 75:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[7, 44, 47, 50], [17, 28, 31, 34], [54, 67, 70, 73]]);
      }));

      function update(_x2) {
        return _update.apply(this, arguments);
      }

      return update;
    }()
  }]);

  return Particles;
}();